const defaultTimes = [
    "9:00",
    "9:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
];

const months = [
    "Січень",
    "Лютий",
    "Березень",
    "Квітень",
    "Травень",
    "Червень",
    "Липень",
    "Серпень",
    "Вересень",
    "Жовтень",
    "Листопад",
    "Грудень",
];

const monthsRegistration = [
    "Січня",
    "Лютого",
    "Березня",
    "Квітня",
    "Травня",
    "Червня",
    "Липня",
    "Серпня",
    "Вересня",
    "Жовтня",
    "Листопада",
    "Грудня",
];

const serviceData = [
    { id: 1, description: "Криптоконсультація", price: 8000 },
    { id: 2, description: "Консультація", price: 6000 },
    { id: 3, description: "Консультація керуючого партнера", price: 12000 },
    { id: 4, description: "Консультація партнера", price: 8000 },
];

export { defaultTimes, months, serviceData, monthsRegistration };
